import { useFormik } from 'formik'
import React from 'react'
import { Button, Form } from 'react-bootstrap'
import * as Yup from "yup" 

const Inputs = () => {

  const initialValues = {
    firstName:"",
    lastName:"",
    email:"",
    password:""
  }

  const validationSchema = Yup.object({
    firstName:Yup
            .string()
            .required("First Name cannot be empty"),
    lastName:Yup
            .string()
            .required("Last Name cannot be empty"),
    email:Yup
            .string()
            .email("Looks like this is not an email")
            .required("Email cannot be empty"),
    password:Yup
            .string()
            .required("Password cannot be empty")
  })

  const onSubmit = ()=>{
    console.log("form validation")
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  return (
    <Form className='form' noValidate onSubmit={formik.handleSubmit}>
      <Form.Group className='input mb-3' controlId='firstName'>
        <Form.Control
            type='text'
            placeholder='First Name'
            {...formik.getFieldProps("firstName")}
            isInvalid={
              formik.touched.firstName &&formik.errors.firstName
            }
            />
        <Form.Control.Feedback type='invalid' className='feedback'>
            {formik.errors.firstName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className='input mb-3' controlId='lastName'>
        <Form.Control
            type='text'
            placeholder='Last Name'
            {...formik.getFieldProps("lastName")}
            isInvalid={formik.touched.lastName && formik.errors.lastName}
            />
        <Form.Control.Feedback type='invalid' className='feedback'>
            {formik.errors.lastName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className='input mb-3' controlId='email'>
        <Form.Control
            type='email'
            placeholder='Email Address'
            {...formik.getFieldProps("email")}
            isInvalid={formik.touched.email && formik.errors.email}
            />
        <Form.Control.Feedback type='invalid' className='feedback'>
            {formik.errors.email}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className='input mb-3' controlId='password'>
        <Form.Control
            type='password'
            placeholder='Password'
            {...formik.getFieldProps("password")}
            isInvalid={formik.touched.password && formik.errors.password}
            />
        <Form.Control.Feedback type='invalid' className='feedback'>
            {formik.errors.password}
        </Form.Control.Feedback>
      </Form.Group>
      <Button id="submitBtn" type='submit'>CLAIM YOUR FREE TRIAL</Button>
      <small>By clicking the button, you are agreeing to our <span>Terms and Services</span></small>
    </Form>
  )
}

export default Inputs
